import { render, staticRenderFns } from "./AdminPanelNotification.vue?vue&type=template&id=179258c8&scoped=true"
import script from "./AdminPanelNotification.vue?vue&type=script&lang=js"
export * from "./AdminPanelNotification.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelNotification.vue?vue&type=style&index=0&id=179258c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179258c8",
  null
  
)

export default component.exports